import React, {PropTypes as T} from 'react';
import Modal from '../../common/modal';
import InfoHeader from '../../common/modal/closeable_info_header';
import translate from '../../../utils/translate';
import CalendarIcon from '../../common/icons/icon_calendar2';
import VenueIcon from '../../common/icons/icon_venue';
import MoreInfoButton from './more_information_button';
import MoreInformation from './more_information';
import TU from '../../common/tu';
import U from './messages_utils';
import modalActions from '../../../actions/modal';
import ExternalLink from '../../common/icons/icon_external_link';

export default class SpecialInfoContent extends React.Component {
  static propTypes = {
    eventInfoName: T.string,
    eventInfoDescription: T.string,
    venue: T.object,
    eventDateTime: T.object,
    eventDateTimeString: T.string,
    modal: T.object,
    promoter: T.object,
    isHiddenDate: T.bool,
    isHiddenTime: T.bool,
    moreDatesUrl: T.string
  };

  state = {slide: false};

  slide = (topicId) => {
    const topic = document.querySelector(`#topic-${topicId}`);
    const moreInfo = document
    .querySelector('.more_information__content_container');

    moreInfo.scrollTop = topic.offsetTop - U.HEADER_OFFSET;

    this.setState({slide: true, clickedId: topicId});
  };

  removeSlide = (e) => {
    e.preventDefault();
    this.setState({slide: false});
  };

  makeSlideFunc = (id) => {
    return (e) => {
      e.preventDefault();
      this.slide(id);
    };
  };

  renderList = (topics) => {
    return topics.map(topic => {
      return <li key={topic.id} className="more_information__list__li">
        <MoreInfoButton
          onClick={this.makeSlideFunc(topic.id)}
          text={topic.name} />
      </li>;
    });
  };

  renderEventDescription = () => {
    return (
      <div className="special_info_content__event_info">
        <h2
          className="special_info__h2"
          data-component="modal-event-information-heading">
          {translate('eventInfoModule', 'EVENT_INFORMATION')}
        </h2>
        <div data-component="modal-event-information-description">
          <TU text={this.props.eventInfoDescription} />
        </div>
        {this.renderEventPromoter()}
      </div>
    );
  };

  renderEventPromoter = () => {
    const {promoter} = this.props;

    if (promoter && promoter.location && promoter.name) {
      return (
        <div className="special_info__promoter">
          <h3
            className="special_info__promoter__content_title"
            data-component="eventdetails-promoter-header">
            {translate('eventInfoModule', 'PROMOTER_DETAILS_HEADER')}
          </h3>
          <div
            className="special_info__promoter_address"
            data-component="eventdetails-promoter-address">
            {promoter.name}{', '}
            {U.generateAddress(promoter.location)}
          </div>
        </div>
      );
    }
    else {
      return false;
    }
  };

  renderMoreDatesUrl = () => {
    if (this.props.moreDatesUrl != null) {
      return (
        <a
          href={this.props.moreDatesUrl}
          className="special_info_content__nav__info__link"
          data-component="attraction-more-dates">
          {translate('eventInfoModule', 'MORE_DATES_LINK')}
          <ExternalLink className="special_info_content__nav__info__external_link_icon" width={10} height={10} />
        </a>
      );
    }
    else {
      return false;
    }
  };

  renderDateTime = () => {
    if (this.props.isHiddenDate) {
      return (
        <div className="special_info_content__nav__info_calendar">
          <CalendarIcon />
          <div
            className="special_info_content__nav__info__text"
            data-component="modal-event-information-date-time">
            {translate('eventInfoModule', 'HIDDEN_DATE')}
          </div>
        </div>
      );
    }
    else if (this.props.isHiddenTime) {
      return (
        <div className="special_info_content__nav__info_calendar">
          <CalendarIcon />
          <div
            className="special_info_content__nav__info__text"
            data-component="modal-event-information-date-time">
            {this.props.eventDateTimeString} {translate('eventInfoModule', 'HIDDEN_TIME')}
            {this.renderMoreDatesUrl()}
          </div>
        </div>
      );
    }
    else {
      return (
        <div className="special_info_content__nav__info_calendar">
          <CalendarIcon />
          <div
            className="special_info_content__nav__info__text"
            data-component="modal-event-information-date-time">
            {this.props.eventDateTimeString}
            {this.renderMoreDatesUrl()}
          </div>
        </div>
      );
    }
  };

  onClose = () => {
    modalActions.hide();
    this.setState({slide: false});
  };

  render () {
    const applySlide = this.state.slide
      ? 'special_info_content__container slide'
      : 'special_info_content__container';

    const applyHide = this.state.slide
      ? 'special_info_content__nav__info hide'
      : 'special_info_content__nav__info';

    return (
      <Modal
        isOpen={this.props.modal.showModal}
        onClose={this.onClose}>
        <InfoHeader onClose={this.onClose} title={this.props.eventInfoName} />
        <div className={applySlide}>
          <div className="special_info_content__event_info_container">
            <div className="special_info_content__nav">
              <div className="special_info_content__nav__info_container">
                <div className={applyHide}>
                  <VenueIcon width={30} />
                  <div
                    className="special_info_content__nav__info__text"
                    data-component="modal-event-information-venue">
                    {U.formatLocation(this.props.venue)}
                  </div>
                </div>
              </div>
              <div className="special_info_content__nav__info_container">
                <div className={applyHide}>
                  {this.renderDateTime()}
                </div>
              </div>
            </div>
            <div className="special_info_content__content_container">
              {this.renderEventDescription()}
              {
                this.props.modal.allInformationTopics.length > 0 &&
                <div>
                  <h2 className="more_information__header">
                    {this.props.modal.translations.INFORMATION_TOPICS_HEADER}
                  </h2>
                  <ul
                    className="more_information__list"
                    data-component="modal-event-information-info-topics">
                    {this.renderList([...this.props.modal.allInformationTopics])}
                  </ul>
                </div>
              }
            </div>
          </div>
          <MoreInformation
            allInformationTopics={this.props.modal.allInformationTopics}
            clickedId={this.state.clickedId}
            show={this.state.slide}
            onClose={this.onClose}
            onBack={this.removeSlide}
            text={this.props.modal.translations.BACK_TO_EVENT_INFORMATION} />
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/messages/special_info_modal_content.js